// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const ERROR = 'ERROR';
export const FIREBASE_STATE_CHANGED = 'FIREBASE_STATE_CHANGED';
